import React from 'react'
import CreditsBalances from './CreditsBalances'
import InvoicesReceipts from './InvoicesReceipts'
import BillingSubscription from './BillingSubscription'
import {useNavigate} from 'react-router-dom'

const BillingOverview: React.FC = () => {
  const navigate = useNavigate()

  const handleNavigateToManage = (productKey: string) => {
    switch (productKey) {
      case 'bcard':
        navigate('/wallet-card')
        break
      case 'livechat':
        navigate('/live-chat')
        break
      case 'dedicated_numbers':
        navigate('/dedicated-numbers')
        break
      default:
        navigate('/dashboard')
    }
  }
  return (
    <>
      <BillingSubscription onNavigateToManage={handleNavigateToManage} />
      <CreditsBalances />
      <InvoicesReceipts />
    </>
  )
}

export default BillingOverview
